import { usePage } from '@inertiajs/vue3'
import { computed } from 'vue'

export function useAuth() {
  const page = usePage()
  const roles = computed(() => page.props.auth.roles)
  const isAdmin = computed(() => roles.value.includes('admin'))
  const isManager = computed(() => roles.value.includes('manager'))
  const isAssociate = computed(() => roles.value.includes('associate'))

  return { isAdmin, isManager, isAssociate, roles }
}
